module.exports = __webpack_public_path__ + "static/media/Functional.7f98dcf6.png";